import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Borrar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_img = _resolveComponent("b-card-img")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_card_body = _resolveComponent("b-card-body")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createBlock(_component_b_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_b_card, {
        "no-body": "",
        class: "overflow-hidden",
        style: {"max-width":"450px"},
        "title-tag": "h3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, { md: "5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_card_img, {
                    src: _ctx.image,
                    alt: "Teacher image",
                    class: "rounded-0"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createVNode(_component_b_col, { md: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_card_body, {
                    title: _ctx.firstname,
                    "title-tag": "h3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_card_text, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.firstname) + " " + _toDisplayString(_ctx.lastname), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createBlock(_component_b_button, {
                            key: 0,
                            pill: "",
                            class: "b-card__button",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDelete(_ctx.userId))),
                            "data-test": "delete"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}